<template>
    <div class="clearfix">
        <div v-if="showLoading">
            Loading...
        </div>
        <div v-if="noResults">
            <br />
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
                There are no indicators to show
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
        <div v-else>

            Indicators
            <table class="table table-dark table-sm table-striped table-hover table-bordered small">                
                <thead>
                    <tr>
                        <th>Date</th>
                        <th scope="col">Bollinger Band</th>
                        <th scope="col">Short MA (15)</th>
                        <th scope="col">Mid MA(45)</th>
                        <th scope="col">Long MA(100)</th>
                        <th scope="col">MACD</th>
                        <th scope="col">Aroon</th>
                        <th scope="col">Stochastic</th>
                        <th scope="col">RSI(14)</th>
                        <th scope="col">MFI(14)</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index" :style="{ opacity: 1-(index*0.1) }" >
                        <td>
                            {{formatDate(item.date)}}
                        </td>
                        <td :class="[ applyColor(item.bBand) ]">{{item.bBand}}
                        </td>
                        <td :class="[ applyColor(item.shortMA15) ]">{{item.shortMA15 }}</td>
                        <td :class="[ applyColor(item.midMA45) ]">{{item.midMA45 }}</td>
                        <td :class="[ applyColor(item.longMA100) ]">{{item.longMA100 }}</td>
                        <td :class="[ applyColor(item.macd) ]">{{item.macd }}</td>
                        <td :class="[ applyColor(item.aroon) ]">{{item.aroon }}</td>
                        <td :class="[ applyColor(item.stochastic) ]">{{item.stochastic }}</td>
                        <td :class="[ applyColor(item.rsI14) ]">{{item.rsI14 }}</td>
                        <td :class="[ applyColor(item.mfI14) ]">{{item.mfI14 }}</td>
                    </tr>
                </tbody>
            </table>
            
        </div>
    </div>
   
</template>

<script>
    import axios from 'axios';    

    export default {
        props: {
            marketparm: Number,
            codeparm: String
        },
        data: function () {
            return {               
                securities : [], 
                items: [],                                
                noResults: false,
                showLoading: true,
                security: this.codeparm,
                marketId: this.marketparm
            }
        },
        async mounted() {
            this.getTrendingStocks();            
        },
        methods: {   

            applyColor(field) {
                if (field == 'Neutral') return "bg-primary";
                if (field == 'Above Top') return 'bg-success';
                if (field == 'Below Bottom') return 'bg-danger';
                if (field == 'Bullish') return 'bg-success';
                
                if (field == 'Bearish') return 'bg-danger';
                if (field == 'Declining') return 'bg-danger';
                if (field == 'Overbought') return 'bg-danger';

                if (field == 'Improving') return 'bg-success';
                if (field == 'Over sold') return 'bg-success';
                
            },
            getData(obj) {
                console.log(obj);                
            },
            getSecurities: function (security) {
                return this.items.find(a => a.security === security)
            },
            filteredMarkets(marketId) {
                return this.items.filter(item => item.marketId === marketId);
            },
            filteredItems(security) {
                return this.items.filter(item => item.security === security);
            },
            filteredDividends(security) {
                return this.dividends.filter(item => item.code === security);
            },
            async getTrendingStocks() {

                const { data } = await axios.get('/api/analysis/getstockindicators', {
                    params: {
                        marketId: this.marketId,
                        code: this.security
                    }
                });

                this.items = data;
                this.noResults = data.length === 0;
                this.showLoading = false;
            }
        }
    }
</script>